import React, { useRef } from 'react';

// tools
import uniqid from '../../../../helpers/uniqid';

const Button3d = ({ children, name, changeFn, checked, disableUntoggle = false, disabled = false }) => {
    const uuid = useRef(uniqid());

    const handleChange = (e) => {
        if (disableUntoggle) {
            changeFn(name)
        } else {
            changeFn(e.target.checked ? name : '', name)
        }
    }

    return(
        <label htmlFor={uuid.current} className={`appButton__3d`}>
            <input
                type="checkbox"
                id={uuid.current}
                onChange={handleChange}
                checked={checked}
                disabled={disabled}/>
            <span>{children}</span>
        </label>
    )
}

export default Button3d;